import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { PropertyDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-property-view-header',
  imports: [CommonModule, RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './property-view-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class PropertyViewHeaderComponent {
  property = input.required<PropertyDto>();
  isOwner = input<boolean>(false);
  backLink = input<string>('/properties');
  backLabel = input<string>('Retour à mes annonces');

  shareClicked = output<void>();
}
